import React from "react";
import styles from './Dashboard.module.css';
import CategoryCard from "../../components/CategoryCard/CategoryCard";
import ServiceGridSection from "./sections/ServiceGridSection";
import { useAuthStore } from "../../store/useAuthStore"; // Import your store

const categories = [
    {
        id: 1,
        icon: "/images/boy.svg",
        title: "Errand Running",
        serviceCount: 124,
    },
    {
        id: 2,
        icon: "/images/plane.svg",
        title: "Travel Assistance",
        serviceCount: 124,
    },
    {
        id: 3,
        icon: "/images/plate.svg",
        title: "Restaurant Reservation",
        serviceCount: 124,
    },
    {
        id: 4,
        icon: "/images/cart.svg",
        title: "Personal Shopping",
        serviceCount: 124,
    },
];

const mockServices = [
    {
        id: 1,
        image: "/images/service1.png",
        agentAvatar: "/images/1.svg",
        agentName: "Grace Helen",
        title: "Book Restaurant Reservations in Lagos",
        rating: 4.9,
        reviewCount: 234,
        location: "Lagos, Nigeria",
        price: 15000,
        status: "Available" as const,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Abuja",
        price: 25000,
        status: "Available" as const,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 20000,
        status: "Available" as const,
    },
    {
        id: 4,
        image: "/images/service4.png",
        agentAvatar: "/images/1.svg",
        agentName: "Bola Ahmed",
        title: "Travel Itinerary Planning",
        rating: 5.0,
        reviewCount: 414,
        location: "Worldwide",
        price: 55000,
        status: "Busy" as const,
    },
    {
        id: 1,
        image: "/images/service1.png",
        agentAvatar: "/images/1.svg",
        agentName: "Grace Helen",
        title: "Book Restaurant Reservations in Lagos",
        rating: 4.9,
        reviewCount: 234,
        location: "Lagos, Nigeria",
        price: 15000,
        status: "Available" as const,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Abuja",
        price: 25000,
        status: "Available" as const,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 20000,
        status: "Available" as const,
    },
    {
        id: 4,
        image: "/images/service4.png",
        agentAvatar: "/images/1.svg",
        agentName: "Bola Ahmed",
        title: "Travel Itinerary Planning",
        rating: 5.0,
        reviewCount: 414,
        location: "Worldwide",
        price: 55000,
        status: "Busy" as const,
    },
];

function DashboardHome() {
    // 1. Pull the user from your mock database
    const currentUser = useAuthStore(state => state.currentUser);
    
    // 2. Extract just their first name for the greeting
    const firstName = currentUser?.fullName?.split(' ')[0] || currentUser?.businessName || 'User';

    return (
        <div className={styles.DashboardContainer}>
            
            {/* NEW: Hero Banner Section */}
            <section className={styles.heroSection}>
                <h1>Welcome back, {firstName}</h1>
                <p>What can we handle for you today?</p>

                <div className={styles.searchWrapper}>
                    <img src="/images/search.svg" alt="Search" className={styles.searchIcon} />
                    <input type="text" placeholder="Search Concierge Services..." className={styles.searchInput}/>
                </div>
            </section>

            {/* EXISTING: Browse by Category */}
            <section className={styles.categorySection}>
                <div className={styles.categoryWrapper}>
                    <h2>Browse by Category</h2>
                    <div className={styles.categoryRow}>
                        {[...categories, ...categories].map((category, index) => (
                            <CategoryCard
                                key={index}
                                icon={category.icon}
                                title={category.title}
                                serviceCount={category.serviceCount}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* You can add your "Recommended for You" grids below here later */}
            <ServiceGridSection 
                title={"Recommended for You"}
                subtitle={"Based on your activity"}
                services={mockServices}
            />

            <ServiceGridSection 
                title={"Popular in Your Area"}
                subtitle={"Top-rated services near you"}
                services={mockServices}
            />

            <ServiceGridSection 
                title={"Recently Added"}
                services={mockServices}
            />

            <div style={{height: '200px'}}>

            </div>
            
        </div>
    );
}

export default DashboardHome;